<script>
export default {
    props: {
        type: {
            type: String,
            default: 'text'
        },
        placeholder: String,
        error: String,
        value: {}
    }
}
</script>

<template>
    <div class="DialogBaseInput" >
        <input :type="type" :placeholder="placeholder" :value="value" @input="$emit('input', $event.target.value)" >
        <div class="errorContainer" >
            <template v-if="error" >
                <img src="./assets/input_error.svg">
                <p>{{error}}</p>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.DialogBaseInput {
    input {
        height: 36px;
        width: 100%;
        background-color: #F0F2F4;
        outline: none;
        border-radius: 3px;
        border:1px solid rgba(240,242,244,1);
        box-sizing: border-box;
        margin-bottom: 6px;
        text-indent: 8px;
        &:focus {
            border:1px solid  #44B1FE;
        }
    }
    .errorContainer {
        display: flex;
        align-items: center;
        height: 20px;
        >img {
            margin-right: 7px;
        }
        >p {
            font-size: 12px;
            color: #FF5E6B;
        }
    }
}
</style>





// WEBPACK FOOTER //
// yotta-vue-components/vision/DialogBaseInput.vue